<template>
  <div id="app">
    <!--  v-if="isRouterAlive" -->

    <router-view :key="key"></router-view>
    <tabbar class="container" v-if="this.$route.meta.showTab"></tabbar>
    <van-popup
      v-model="isWeixin"
      position="top"
      :close-on-click-overlay="false"
    >
      <van-image fit="fill" :src="openbrowser" />
    </van-popup>
  </div>
</template>

<script>
import tabbar from "./components/tabbar";
import { getProjectList } from "@/api/apis";
export default {
  name: "App",
  props: {},
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
      projectList: this.projectList,
      // loadCartList: this.loadCartList,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      isWeixin: false,
      projectList: [],
      openbrowser: require("@/assets/img/openbrowser.jpeg"),
    };
  },
    metaInfo: {
  
    meta: [
      { name: "format-detection", content: "telephone=yes" },
      
    ],
  },
  components: {
    tabbar,
  },
  computed: {
    // 解决路由切换页面不更新
    key() {
      return this.$route.path + Math.random();
    },
  },
  methods: {
    // 刷新页面配置
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    // loadProjectList() {
    //   getProjectList().then()
    // },

    // 获取个人信息
    getUserInfo() {
      let token = localStorage.getItem("token");
      if (token) {
        this.$store.commit("setToken", token);
        this.$store.dispatch("syncUpdateUserInfo", token);
        console.log("project")
        this.$store.dispatch("syncGetProjectList", token);
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },

  mounted() {
    var ua = navigator.userAgent;
    this.isWeixin = !!/MicroMessenger/i.test(ua);
    let flag = this._isMobile();
    console.log("mounted", flag);
    if (flag == null) {
      // if(localStorage.getItem("sid") == 'shopvill' || localStorage.getItem("sid")== '' || localStorage.getItem("sid") == null){
      // window.location.href = "indexpc.html";
      // window.location.href = "/";
      //return;
      // }
      // window.location.href = "indexpc.html?sid=" + localStorage.getItem("sid");
      //return;
    }

    console.log("van-popup", this.isWeixin);
    this.$nextTick(() => {
      this.getUserInfo()
      //this.loadProjectList()
    });
  },
};
</script>
<style scoped lang="less">
#app {
  min-height: 100vh;
  background: #fff;
}

.container {
  margin-bottom: 50px;
}
</style>